import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import PreferredLanguageSelect, { preferredLanguageOrDefault } from "../../../../components/preferredLanguageSelect";
import { Formik } from "formik";
import { useSelector } from "react-redux";

import {
  requestScreenNameChange,
  updateInitialProfile,
} from "../../../../services/profile";
import { setLoading } from "../../../../reducer/auth/auth";
import { useDispatch } from "react-redux";
import { TagsInput } from "react-tag-input-component";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { updateUserEmail, fetchUser } from "../../../../services/auth";
import PhoneInputField from "../../../../components/Inputfields/phoneinput";
import Button from "../../../../components/button";
import ProfilePicture from "../subcomponent/profilepicture";
import { setNewTimeZoneData, setUser } from "../../../../reducer/userSlice";
import {
  filterVisibleTimeZones,
  localization,
  toolbar,
} from "../../../../utils/helpers";

//editors
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw, convertFromRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { Link } from "react-router-dom";
import { set } from "date-fns";
import TimeDisplay from "../../../../components/TimeDisplay";
// import {Editors} from "../../../../components/editor";

// import { getCountryCode } from "../../../../utils/helpers";
export default function Profile(props) {
  const { t } = useTranslation("mediumProfile");
  const dispatch = useDispatch();
  const {
    // stepTwoData,
    formLanguages,
    specialtyData,
    countryData,
    stepOneData,
    getProfile,
    timezoneData,
    reloadTimeZones
    // timezoneOnly,
  } = props;
   const {
        timezone,
        id,
        is_on_demand_box,
        cache_clear_confirmations,
        timezone_name,
        test_mode,

    } = useSelector((state) => state.user.user);

      const auth = useSelector((state) => state.auth);

  // const [formData,setFormData] = useState(stepOneData)
  const [newformData, setNewFormData] = useState([]);
  const [newSpecilityData, setNewSpecilityData] = useState([]);
  const [newCountryData, setNewCountryData] = useState([]);
  const [newTimezoneData, setnewTimezoneData] = useState([]);
  const [openOtherLnaguages, setOpenOtherLnaguages] = useState(false);
  const [openOtherSpecility, setOpenOtherSpecility] = useState(false);
  // const [userCountryCode, setUserCountryCode] = useState("US");
  const [userCountryCodeChange] = useState("US");
  const [requestChangePhoneNo, setRequestChangePhoneNo] = useState(false);
  const [newPhoneNo, setNewPhoneNo] = useState("");
  const [
    requestChangeSuceessMessagePhoneNo,
    setrequestChangeSuceessMessagePhoneNo,
  ] = useState("");

  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [editorState1, setEditorState1] = useState(EditorState.createEmpty());
  const [editorState3, setEditorState3] = useState(EditorState.createEmpty());
  const [contentState, setContentState] = useState(null);
  const [contentState1, setContentState1] = useState(null);
  const [editorLoaded, setEditorLoaded] = useState(false);
  const [data, setData] = useState("");
   const [emailValue, setEmailValue] = useState("");
  const [emailError, setEmailError] = useState("");
  const [emailMessage, setEmailMessage] = useState("");

  const mediumshipSpecialitiesRef = useRef(null);
  const countryRef = useRef(null);
  const mediumshipLevelRef = useRef(null);
  const timezoneRef = useRef(null);

  // Status messages are kept in English in state (they are compared in code)
  // and only translated when displayed.
  const messageKeys = {
    "You have successfully submitted Request for Phone No change":
      "profile.messages.phoneChangeSubmitted",
    "New Phone No is required": "profile.messages.newPhoneRequired",
    "You have successfully submitted Request for Email change":
      "profile.messages.emailChangeSubmitted",
    "*Required": "profile.messages.required",
    "*Invalid Email": "profile.messages.invalidEmail",
  };
  const translateMessage = (message) =>
    message && messageKeys[message]
      ? t(messageKeys[message], { defaultValue: message })
      : message;

  useEffect(() => {
  if (!stepOneData) return;

  const parseContent = (raw) => {
    if (!raw) return "";

    try {
      if (!isHTML(raw)) {
        return raw
          .split("\n")
          .map((line) => `<p>${line}</p>`)
          .join("");
      } else {
        return JSON.parse(raw).content;
      }
    } catch (e) {
      console.error("Failed to parse content:", e);
      return "";
    }
  };

  const htmlBio = parseContent(stepOneData.biographicalInfo);
  if (htmlBio) {
    const blocks = htmlToDraft(htmlBio);
    const content = ContentState.createFromBlockArray(blocks.contentBlocks);
    setEditorState(EditorState.createWithContent(content));
  }

}, [stepOneData]);
  useEffect(() => {
    setNewFormData(
      formLanguages.map((item) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
        };
      })
    );
    setNewSpecilityData(
      specialtyData.map((item) => {
        return {
          ...item,
          value: item.id,
          label: item.specialty_name,
        };
      })
    );
    setNewCountryData(
      countryData.map((item) => {
        return {
          ...item,
          value: item.id,
          label: item.country_name,
        };
      })
    );
    setnewTimezoneData(filterVisibleTimeZones(timezoneData));
  }, [formLanguages, specialtyData, countryData, timezoneData]);
  function isHTML(str) {
    const doc = new DOMParser().parseFromString(str, "text/html");
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
  }
  useEffect(() => {
  if (!stepOneData) return;

  const timeout = setTimeout(() => {
    const parseContent = (raw) => {
      if (!raw) return "";

      try {
        if (!isHTML(raw)) {
          return raw
            .split("\n")
            .map((line) => `<p>${line}</p>`)
            .join("");
        } else {
          return JSON.parse(raw).content;
        }
      } catch (e) {
        console.error("Failed to parse content:", e);
        return "";
      }
    };

    // Biographical Info
    const htmlBio = parseContent(stepOneData.biographicalInfo);
    if (htmlBio) {
      const blocksFromHtml = htmlToDraft(htmlBio);
      const contentState = ContentState.createFromBlockArray(blocksFromHtml.contentBlocks);
      setEditorState(EditorState.createWithContent(contentState));
    }

    // Cancellation Policy
    const htmlCancel = parseContent(stepOneData.cancellation_policy);
    if (htmlCancel) {
      const blocksFromHtml1 = htmlToDraft(htmlCancel);
      const contentState1 = ContentState.createFromBlockArray(blocksFromHtml1.contentBlocks);
      setEditorState1(EditorState.createWithContent(contentState1));
    }

    // Biographical Info
    const htmlBio2 = parseContent(stepOneData.asACoach);
    if (htmlBio2) {
      const blocksFromHtml2 = htmlToDraft(htmlBio2);
      const contentState = ContentState.createFromBlockArray(blocksFromHtml2.contentBlocks);
      setEditorState3(EditorState.createWithContent(contentState));
    }
  }, 5000);

  return () => clearTimeout(timeout); // Cleanup timeout if component unmounts

}, [stepOneData]);
  const handleContentStateChange = (contentState) => {
    console.log(contentState, 'contentState')
    setContentState(draftToHtml(contentState));
  };
  const handleContentStateChange1 = (contentState) => {
    console.log(contentState, 'contentState')
    setContentState1(draftToHtml(contentState));
  };

  const handleEditorStateChange = (editorState, setFieldValue, name) => {
    console.log(editorState.getCurrentContent());
    setFieldValue(name, JSON.stringify(editorState));
    setEditorState(editorState);
  };

  const onSaveContent = () => {
    const contentState = editorState.getCurrentContent();
    const content = JSON.stringify(convertToRaw(contentState));
    console.log(content);
    return content;
    // Send `content` to your server for storage
    // You can use an API call (e.g., Axios) to send the data to your backend
  };
  const RunFunction = (formData) => {
    console.log(formData, "formData");
    dispatch(setLoading(true));
    // setValues(formData);
    const rawHtml = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    const rawHtml1 = draftToHtml(convertToRaw(editorState1.getCurrentContent()));
    const rawHtml2 = draftToHtml(convertToRaw(editorState3.getCurrentContent()));
    const {
      phone,
      whatsapp,
      languages,
      mediumshipLevel,
      mediumshipSpecialities,
      country,
      website,
      biographicalInfo,
      asACoach,
      otherLanguages,
      otherMediumSpecialities,
      timezone,
      medium_professional_category,
      mediumship_level_admin,
      session_lengths,
      session_lengths_currency,
      cancellation_policy,
    } = formData;

    dispatch(setNewTimeZoneData(filterTimeZone(timezone.id)));

    let lang = languages.map((item) => {
      return item.id;
    });
    let speci = mediumshipSpecialities.map((item) => {
      return item.id;
    });

    // let count = country.map((item)=> {return item.id})
    // console.log(lang,speci,count)
    let item = {
      // first_name: firstName,
      // last_name: lastName,
      phone: phone,
      whatsapp: whatsapp,
      website: website,
      cancellation_policy: JSON.stringify({ content: rawHtml1 }),
      country: country.label !== undefined ? country.label : country,
      languages: lang,
      preferred_communication_language: preferredLanguageOrDefault(formData.preferred_communication_language),
      mediumship_specialties: speci,
      current_mediumship_level: parseInt(mediumshipLevel),
      // biographical_info:onSaveContent(),
      biographical_info: JSON.stringify({ content: rawHtml }),
      // as_a_coach: JSON.stringify({ content: rawHtml2 }),
      other_languages: otherLanguages,
      other_mediumship_specialties: otherMediumSpecialities,
      timezone: timezone.id,
      medium_professional_category: medium_professional_category,
      mediumship_level: mediumship_level_admin,
      // when_do_i_pay: when_do_i_pay,
      session_length: session_lengths,
      session_currency: session_lengths_currency,
    };
    updateInitialProfile(item)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          toast.success(t("toast.profileUpdated"), { position: "top-center" });
          // Fetch updated user data for cross-tab sync
          fetchUser().then((userData) => {
            dispatch(setUser(userData.data.data));
            localStorage.setItem('userTimezone', JSON.stringify(userData.data.data));
          }).catch((err) => console.log(err));
          getProfile();
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };

  const filterTimeZone = (id) => {
    let zone;
    timezoneData.filter((item) => {
      if (parseInt(id) === parseInt(item.id)) {
        zone = item.front_name;
      }
    });
    return zone;
  };

  const countryChangeHandler = (value, name, setFieldValue) => {
    // setUserCountryCode(value.country_code);
    setFieldValue(name, value);
  };
  const requestChangeHandler = () => {
    setRequestChangePhoneNo(true);

    setrequestChangeSuceessMessagePhoneNo("");
    if (requestChangePhoneNo) {
      if (newPhoneNo !== "") {
        let body = {
          type: "phone",
          value: newPhoneNo,
        };
        requestScreenNameChange(body)
          .then((data) => {
            if (data.data.status) {
              setrequestChangeSuceessMessagePhoneNo(
                "You have successfully submitted Request for Phone No change"
              );
            }
          })
          .catch(() => { });
      } else {
        setrequestChangeSuceessMessagePhoneNo("New Phone No is required");
      }
    }
  };
  // const onEditorStateChange = (e) => {
  //   console.log(e)
  //   setBiostate(e);
  // };
  const onChangeTimeZoneHanlder = () => {
    console.log(newTimezoneData);
    if (newTimezoneData.length > 0) {
      return;
    }
    reloadTimeZones();
  }
   const handleChangeEmail = (e) => {
    setEmailValue(e.target.value);
    if (e.target.value === "") {
      setEmailError("*Required");
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(e.target.value)
    ) {
      setEmailError("*Invalid Email");
    } else {
      setEmailError("");
    }
  };
  const onChangeEmailHandler = (setFieldValue) => {
    if (emailValue !== "" && emailError === "") {
      // setEmailDisabled(false);
      // setEmailTitle("Submit");
      // if (emailTitle === "Submit" && emailError === "" && emailValue !== "") {
       let body = {
          type: "email",
          value: emailValue,
        };
      requestScreenNameChange(body)
        .then((data) => {
          if (data.data.status) {
           
            setEmailMessage("You have successfully submitted Request for Email change");
          }
        })
        .catch(() => {});
    } else {
      setEmailError("*Required");
      return;
    }
  };
  const getInitialValues = () => {
  if (!stepOneData) return {};

  return {
    ...stepOneData,

    
  };
};

  const showFormErrors = (errors) => {
    if (Object.keys(errors).length > 0) {
      toast.error(t("toast.completeRequired"), {
        position: "top-center",
      });
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  };

  const focusFirstInvalidField = (errors) => {
    const fieldOrder = [
      { key: "mediumshipSpecialities", ref: mediumshipSpecialitiesRef },
      { key: "country", ref: countryRef },
      { key: "mediumshipLevel", ref: mediumshipLevelRef },
      { key: "timezone", ref: timezoneRef },
    ];

    for (const field of fieldOrder) {
      if (errors[field.key] && field.ref.current) {
        field.ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
        const inputEl = field.ref.current.querySelector(
          "input, select, textarea, [tabindex='0'], [role='combobox']"
        );
        if (inputEl && typeof inputEl.focus === "function") {
          inputEl.focus();
        }
        break;
      }
    }
  };

  return (
    <div>
      {/* {(parseInt(stepOneData.mediumship_level_admin) === 3 || parseInt(stepOneData.mediumship_level_admin) === 6 || parseInt(stepOneData.mediumship_level_admin) === 7) && <ProfilePicture />} */}
      <ProfilePicture
        mediumship_level_admin={stepOneData.mediumship_level_admin}
        URL={stepOneData.token_url}
      />
      <Formik
        initialValues={getInitialValues()}
        enableReinitialize={true}
        
        validate={(values) => {
          const errors = {};
          if (!values.mediumshipSpecialities.length)
            errors.mediumshipSpecialities = t("common:validation.required");

          // if (!values.phone) errors.phone = "Required";
          // if (!values.whatsapp) errors.whatsapp = "Required";
          if (!values.country) errors.country = t("common:validation.required");
          // if (!values.website) errors.website = "Required";
          if (!values.mediumshipLevel) errors.mediumshipLevel = t("common:validation.required");
          // if (!values.biographicalInfo) errors.biographicalInfo = "Required";

          // if (values.phone && !/^[0-9]+$/.test(values.phone)) {
          //   errors.phone = "Invalid Phone";
          // }
          // if (values.whatsapp && values.whatsapp.length < 10) {
          //   errors.phone = "Invalid whatsapp";
          // }
          if (values.phone && values.phone.length < 10) {
            errors.phone = t("profile.validation.invalidPhone");
          }
          // if (values.whatsapp && !/^[0-9]+$/.test(values.whatsapp)) {
          //   errors.whatsapp = "Invalid whatsapp";
          // }
          if (!values.timezone) errors.timezone = t("common:validation.required");
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          RunFunction(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          handleSubmit,
          isSubmitting,
          setFieldTouched,
        }) => (
          <form
            onSubmit={(e) => {
              if (Object.keys(errors).length > 0) {
                showFormErrors(errors);
                focusFirstInvalidField(errors);
              }
              handleSubmit(e);
            }}
            className="tab-pane"
            role="tabpanel"
            id="step1"
          >
            <div className="row-one-step">
              <div className="left-side">
                <label>
                  {t("profile.phone")} <i>*</i>
                </label>
                <PhoneInputField
                  className={`number-input ${errors.phone && touched.phone && errors.phone
                    ? "error-boundry"
                    : ""
                    }`}
                  // country={userCountryCode.toLowerCase()}
                  country="us"
                  setFieldValue={setFieldValue}
                  onBlur={handleBlur}
                  value={values.phone}
                  id="phone"
                  name="phone"
                  disabled={true}
                />
                <div className=" mt-2">
                  <div>
                    {requestChangePhoneNo && (
                      <>
                        <label>
                          {t("profile.newPhone")}<i>*</i>
                        </label>
                        <PhoneInputField
                          country={userCountryCodeChange.toLowerCase()}
                          onBlur={handleBlur}
                          value={newPhoneNo}
                          setValue={setNewPhoneNo}
                          id="updatedphone"
                          name="updatedphone"
                        />
                      </>
                    )}
                    <div className="mt-2">
                      <Button
                        status={0}
                        type="button"
                        className={`resend-btn w-unset height-45 min-width-130px`}
                        onClick={requestChangeHandler}
                        title={
                          requestChangePhoneNo
                            ? t("buttons.submit")
                            : t("buttons.requestChange")
                        }
                      />
                    </div>
                  </div>
                  <div
                    className={`text-left ${requestChangeSuceessMessagePhoneNo ===
                      "New Phone No is required"
                      ? "red"
                      : "green"
                      }`}
                  >
                    {translateMessage(requestChangeSuceessMessagePhoneNo)}
                  </div>
                </div>
                {/* <input
                className={`${
                  errors.phone && touched.phone && errors.phone
                    ? "error-boundry"
                    : ""
                }`}
                onChange={(e) => handleChangeHandler(e, "phone", setFieldValue)}
                onBlur={handleBlur}
                value={values.phone}
                id="phone"
                name="phone"
                type="tel"
              /> */}
                <span className="error">
                  {errors.phone && touched.phone && errors.phone}
                </span>
              </div>
              <div className="right-side">
                <label>{t("profile.whatsapp")}</label>
                <PhoneInputField
                  className={`${errors.whatsapp && touched.whatsapp && errors.whatsapp
                    ? "error-boundry"
                    : ""
                    }`}
                  // country={userCountryCode.toLowerCase()}
                  country="us"
                  setFieldValue={setFieldValue}
                  onBlur={handleBlur}
                  value={values.whatsapp}
                  id="whatsapp"
                  name="whatsapp"
                />
                {/* <input
                onChange={(e) =>
                  handleChangeHandler(e, "whatsapp", setFieldValue)
                }
                onBlur={handleBlur}
                value={values.whatsapp}
                id="whatsapp"
                name="whatsapp"
                type="tel"
              /> */}
                <span className="error">
                  {errors.whatsapp && touched.whatsapp && errors.whatsapp}
                </span>
              </div>
            </div>
             <div className="row-one-step">
               <label>
                 {t("profile.currentEmail", { email: values.email })}
               </label>
              <label>{t("profile.updateEmail")}</label>
              <div className="verification-code-section mt-3">
                <div className="d-flex">
                  <>
                    {" "}
                    <input
                      onChange={handleChangeEmail}
                      onBlur={handleBlur}
                      className={`height-45 margin-right-30 `}
                      value={emailValue}
                      type="text"
                      id="changeemail"
                      name="changeemail"
                      placeholder={t("profile.emailPlaceholder")}
                      // disabled={emailDisabled}
                    />
                    <span className="error marg-top-55">{translateMessage(emailError)}</span>
                  </>

                  <div className="mobile-div">
                    <Button
                      status={0}
                      type="button"
                      className={`resend-btn w-unset height-45 min-width-130px`}
                      onClick={() => onChangeEmailHandler(setFieldValue)}
                      title={t("buttons.requestChange")}
                    />
                  </div>
                  
                </div>

                <div className={`text-left green`}>
                  <span>{translateMessage(emailMessage)}</span>
                </div>
              </div>
            </div>
            <div className="row-one-step" ref={mediumshipLevelRef}>
              <div className="full-side">
                <label>
                  {t("profile.languages")}<i>*</i>
                </label>
                <Select
                  id="languages"
                  className="selection-box"
                  options={newformData}
                  multi={true}
                  isMulti
                  onChange={(value) => setFieldValue("languages", value)}
                  onBlur={handleBlur}
                  placeholder={t("profile.selectLanguages")}
                  value={values.languages}
                  closeMenuOnSelect={false}
                  closeMenuOnScroll={false}
                />
                <span
                  onClick={() => setOpenOtherLnaguages(!openOtherLnaguages)}
                  className="other-lang pointer"
                >
                  {t("profile.otherLanguage")}
                </span>
                {openOtherLnaguages && (
                  <TagsInput
                    value={values.otherLanguages}
                    className="form-other-tags-input"
                    name="otherLanguages"
                    onChange={(value) => setFieldValue("otherLanguages", value)}
                    placeHolder={t("profile.otherLanguage")}
                  />
                )}
                <span className="error">
                  {errors.languages && touched.languages && errors.languages}
                </span>
              </div>
            </div>
            <div className="row-one-step">
              <div className="full-side">
                <label>
                  {t("common:common.preferredCommunication")}<i>*</i>
                </label>
                <PreferredLanguageSelect
                  value={preferredLanguageOrDefault(values.preferred_communication_language)}
                  onChange={(code) => setFieldValue("preferred_communication_language", code)}
                  onBlur={handleBlur}
                />
              </div>
            </div>
            <div className="row-one-step" ref={mediumshipSpecialitiesRef}>
              <div className="full-side">
                <label>
                  {t("profile.currentMediumshipLevel")}
                  <i>*</i>
                </label>
                <div className="InputGroup">
                  <div className="radio-box">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      type="radio"
                      name="mediumshipLevel"
                      id="size_1"
                      value={1}
                      checked={
                        parseInt(values.mediumshipLevel) === 1 ? true : false
                      }
                    />
                    <label htmlFor="size_1">{t("profile.levels.novice")}</label>
                  </div>
                  <div className="radio-box">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      type="radio"
                      name="mediumshipLevel"
                      id="size_2"
                      value={2}
                      checked={
                        parseInt(values.mediumshipLevel) === 2 ? true : false
                      }
                    />
                    <label htmlFor="size_2">
                      {t("profile.levels.intermediate")}
                    </label>
                  </div>
                  <div className="radio-box">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      type="radio"
                      name="mediumshipLevel"
                      id="size_3"
                      value={3}
                      checked={
                        parseInt(values.mediumshipLevel) === 3 ? true : false
                      }
                    />
                    <label htmlFor="size_3">
                      {t("profile.levels.professional")}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {/***if professinal */}
            {parseInt(values.mediumshipLevel) === 3 && (
              <div className="from-inner-box radeo">
                <div className="full-fild">
                  <label>
                    {t("profile.yearsAsProfessional")} <i>*</i>
                  </label>
                  <div className="InputGroup">
                    <div className="radio-box">
                      <input
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="radio"
                        name="medium_professional_category"
                        id="medium_professional_category_1"
                        value={1}
                        checked={
                          parseInt(values.medium_professional_category) === 1
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="medium_professional_category_1">
                        {t("profile.years.year1")}
                      </label>
                    </div>
                    <div className="radio-box">
                      <input
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="radio"
                        name="medium_professional_category"
                        id="medium_professional_category_2"
                        value={2}
                        checked={
                          parseInt(values.medium_professional_category) === 2
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="medium_professional_category_2">
                        {t("profile.years.years2to3")}
                      </label>
                    </div>
                    <div className="radio-box">
                      <input
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="radio"
                        name="medium_professional_category"
                        id="medium_professional_category_3"
                        value={3}
                        checked={
                          parseInt(values.medium_professional_category) === 3
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="medium_professional_category_3">
                        {t("profile.years.years3to5")}
                      </label>
                    </div>
                    <div className="radio-box">
                      <input
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="radio"
                        name="medium_professional_category"
                        id="medium_professional_category_4"
                        value={4}
                        checked={
                          parseInt(values.medium_professional_category) === 4
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="medium_professional_category_4">
                        {t("profile.years.years5to10")}
                      </label>
                    </div>
                    <div className="radio-box">
                      <input
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="radio"
                        name="medium_professional_category"
                        id="medium_professional_category_5"
                        value={5}
                        checked={
                          parseInt(values.medium_professional_category) === 5
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="medium_professional_category_5">
                        {t("profile.years.years10to15")}
                      </label>
                    </div>
                    <div className="radio-box">
                      <input
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="radio"
                        name="medium_professional_category"
                        id="medium_professional_category_6"
                        value={6}
                        checked={
                          parseInt(values.medium_professional_category) === 6
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="medium_professional_category_6">
                        {t("profile.years.years15plus")}
                      </label>
                    </div>
                  </div>
                  <span className="error text-left">
                    {errors.mediumshipLevel &&
                      touched.mediumshipLevel &&
                      errors.mediumshipLevel}
                  </span>
                </div>
              </div>
            )}
            {/*****New section***** */}

            {(parseInt(values.mediumship_level_admin) === 3 ||
              parseInt(values.mediumship_level_admin) === 6 ||
              parseInt(values.mediumship_level_admin) === 7) && (
                <>
                  <div className="row-one-step">
                    <div className="full-side">
                      <label>{t("profile.whenDoIPay")}</label>
                      <div className="full-fild">
                        <div className="check-field">
                          <input
                            disabled
                            // onChange={handleChange}
                            // onBlur={handleBlur}
                            type="checkbox"
                            name="when_do_i_pay"
                            id="when_do_i_pay_1"
                            value={"1"}
                            checked={
                              values.when_do_i_pay.includes("1") ? true : false
                            }
                          // checked={
                          //   parseInt(values.when_do_i_pay) === 1 ? true : false
                          // }
                          />
                          <label className=" w-unset" htmlFor="when_do_i_pay_1">
                            {t("profile.payToBook")}
                          </label>
                        </div>
                        <div className="check-field">
                          <input
                            // onChange={handleChange}
                            // onBlur={handleBlur}
                            disabled
                            type="checkbox"
                            name="when_do_i_pay"
                            id="when_do_i_pay_2"
                            value={"2"}
                            checked={
                              values.when_do_i_pay.includes("2") ? true : false
                            }
                          // checked={
                          //   parseInt(values.when_do_i_pay) === 2 ? true : false
                          // }
                          />
                          <label htmlFor="when_do_i_pay_2" className=" w-unset">
                            {t("profile.payAfterSession")}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/******************** */}
                  {/* {(parseInt(values.mediumship_level_admin) === 3 ||
                    parseInt(values.mediumship_level_admin) === 6 ||
                    parseInt(values.mediumship_level_admin) === 7) && (
                      <>
                        <div className="row-one-step p-2">
                          <div className="full-side">
                            <label>
                              Session Currency :{" "}
                              <span className="color-d5a67b font-size-18">
                                {values.session_length_30_currency}
                              </span>{" "}
                            </label>
                          </div>
                        </div>
                      </>
                    )} */}
                  {/* <div className="row-one-step new-step-row">
                    <div className="full-side">
                      <label>
                        Session Length &nbsp; &nbsp; &nbsp;{" "}
                        <Link className="text-underline" to={"/pricing"}>
                          Click here to adjust session prices.
                        </Link>
                      </label> */}
                      {/* <div className="InputGroup">
                    <div className="radio-box">
                      <input
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="radio"
                        name="session_length"
                        id="size_1_session_length"
                        value={30}
                        checked={
                          parseInt(values.session_length) === 30 ? true : false
                        }
                      />
                      <label
                        className=" w-unset"
                        htmlFor="size_1_session_length"
                      >
                        30 Minutes
                      </label>
                    </div>
                    <div className="radio-box">
                      <input
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="radio"
                        name="session_length"
                        id="size_2_session_length"
                        value={45}
                        checked={
                          parseInt(values.session_length) === 45 ? true : false
                        }
                      />
                      <label
                        htmlFor="size_2_session_length"
                        className=" w-unset"
                      >
                        45 Minutes
                      </label>
                    </div>
                    <div className="radio-box">
                      <input
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="radio"
                        name="session_length"
                        id="size_3_session_length"
                        value={60}
                        checked={
                          parseInt(values.session_length) === 60 ? true : false
                        }
                      />
                      <label
                        htmlFor="size_3_session_length"
                        className=" w-unset"
                      >
                        60 Minutes
                      </label>
                    </div>
                  </div> */}
                    {/* </div> */}
                    {/* stepOneData.mediumship_level */}

                    {/* {(parseInt(values.mediumship_level_admin) === 3 ||
                      parseInt(values.mediumship_level_admin) === 6 ||
                      parseInt(values.mediumship_level_admin) === 7) && (
                        <>
                          <div className="w-25 mt-2 ml-5">
                            <label>30 Minutes</label>
                            <input
                              className="p-2 amount_input"
                              // onChange={handleChange}
                              // onBlur={handleBlur}
                              disabled
                              value={values.session_length_30}
                              id={"session_length_30"}
                              name={"session_length_30"}
                              type="text"
                              placeholder="Amount"
                            />
                          </div>
                          <div className="w-25 mt-2 ml-5">
                            <label>45 Minutes</label>

                            <input
                              className="p-2 amount_input"
                              // onChange={handleChange}
                              // onBlur={handleBlur}
                              disabled
                              value={values.session_length_45}
                              id={"session_length_45"}
                              name={"session_length_45"}
                              type="text"
                              placeholder="Amount"
                            />
                          </div>
                          <div className="w-25 mt-2 ml-5">
                            <label>60 Minutes</label>

                            <input
                              className="p-2 amount_input"
                              // onChange={handleChange}
                              // onBlur={handleBlur}
                              disabled
                              value={values.session_length_60}
                              id={"session_length_60"}
                              name={"session_length_60"}
                              type="text"
                              placeholder="Amount"
                            />
                          </div>
                          <div className="w-25 mt-2 ml-5">
                            <label>45 Minutes for 2 People</label>

                            <input
                              className="p-2 amount_input"
                              // onChange={handleChange}
                              // onBlur={handleBlur}
                              disabled
                              value={values.session_length_45_2}
                              id={"session_length_45_2"}
                              name={"session_length_45_2"}
                              type="text"
                              placeholder="Amount"
                            />
                          </div>
                          <div className="w-25 mt-2 ml-5">
                            <label>60 Minutes for 2 People</label>

                            <input
                              className="p-2 amount_input"
                              // onChange={handleChange}
                              // onBlur={handleBlur}
                              disabled
                              value={values.session_length_60_2}
                              id={"session_length_60_2"}
                              name={"session_length_60_2"}
                              type="text"
                              placeholder="Amount"
                            />
                          </div> */}
                        {/* </>
                      )}
                  </div> */}
                  {/******New section**** */}
                </>
              )}

            <div className="row-one-step">
              <div className="full-side">
                <label>
                  {t("profile.specialities")}<i>*</i>
                </label>
                <Select
                  id="mediumshipSpecialities"
                  className="selection-box"
                  options={newSpecilityData}
                  multi={true}
                  isMulti
                  onChange={(value) =>
                    setFieldValue("mediumshipSpecialities", value)
                  }
                  onBlur={handleBlur}
                  placeholder={t("profile.selectSpecialities")}
                  value={values.mediumshipSpecialities}
                  closeMenuOnSelect={false}
                  closeMenuOnScroll={false}
                />

                <span
                  onClick={() => setOpenOtherSpecility(!openOtherSpecility)}
                  className="other-lang pointer"
                >
                  {t("profile.otherSpecialities")}
                </span>
                {openOtherSpecility && (
                  <TagsInput
                    value={values.otherMediumSpecialities}
                    className="form-other-tags-input"
                    onChange={(value) =>
                      setFieldValue("otherMediumSpecialities", value)
                    }
                    name="otherSpecialities"
                    placeHolder={t("profile.otherSpecialities")}
                  />
                )}
                <span className="error">
                  {errors.mediumshipSpecialities &&
                    touched.mediumshipSpecialities &&
                    errors.mediumshipSpecialities}
                </span>
              </div>
            </div>
            <div className="row-one-step">
              <div className="left-side" ref={countryRef}>
                <label>
                  {t("profile.country")} <i>*</i>
                </label>
                {/* <input type="text" placeholder="United States" /> */}
                {values.country && (
                  <Select
                    id="country"
                    className="selection-box"
                    options={newCountryData}
                    // multi={true}
                    // isMulti
                    onChange={(value) =>
                      countryChangeHandler(value, "country", setFieldValue)
                    }
                    onBlur={handleBlur}
                    placeholder={t("profile.countryPlaceholder")}
                    defaultInputValue={values.country}
                    value={values.country}
                    closeMenuOnSelect={true}
                    closeMenuOnScroll={true}
                  />
                )}
                {!values.country && (
                  <Select
                    id="country"
                    className="selection-box"
                    options={newCountryData}
                    // multi={true}
                    // isMulti
                    onChange={(value) =>
                      countryChangeHandler(value, "country", setFieldValue)
                    }
                    onBlur={handleBlur}
                    placeholder={t("profile.countryPlaceholder")}
                    defaultInputValue={values.country}
                    value={values.country}
                    closeMenuOnSelect={true}
                    closeMenuOnScroll={true}
                  />
                )}
                <span className="error">
                  {errors.country && touched.country && errors.country}
                </span>
              </div>
              {parseInt(values.mediumshipLevel) === 3 && (
                <div className="right-side cuntrey-website">
                  <label>{t("profile.website")}</label>
                  <input
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.website}
                    id="website"
                    name="website"
                    type="text"
                    placeholder="yourwebsite.com"
                  />
                </div>
              )}
            </div>
            {auth.role == "medium" && (
            <div className="row-one-step" style={{marginBottom:"-10px"}}>
              <label>{t("profile.timezone")}<i>*</i></label>
              <TimeDisplay format="HH:mm:ss A" />
            </div>
            )}
            <div className="row-one-step" ref={timezoneRef}>
               {auth.role != "medium" && ( <label>
                {/* auth.role == "medium" */}
                {t("profile.timezone")}<i>*</i>
                {/* <img
                  title="Reload TimeZones"
                  onClick={(e) => reloadTimeZones("refresh")}
                  className="googl-link-copy-img copy-image-animate refresh-btn-app mt-4"
                  alt="Reload TimeZones"
                  src="/images/refresh.png"
                /> */}
              </label>
               )}
              {values.timezone && (
                <Select
                  id="timezone"
                  className="selection-box"
                  options={newTimezoneData}
                  onChange={(value) => setFieldValue("timezone", value)}
                  onBlur={handleBlur}
                  placeholder={t("profile.selectTimezone")}
                  defaultValue={values.timezone}
                  // defaultInputValue={values.timezone.front_name}
                  value={values.timezone}
                  closeMenuOnSelect={true}
                  closeMenuOnScroll={true}
                  onMenuOpen={onChangeTimeZoneHanlder}
                />
              )}
              {!values.timezone && (
                <Select
                  id="timezone"
                  className="selection-box"
                  options={newTimezoneData}
                  onChange={(value) => setFieldValue("timezone", value)}
                  onBlur={handleBlur}
                  // defaultInputValue={values.timezone.front_name}
                  defaultValue={values.timezone}
                  placeholder={t("profile.selectTimezone")}
                  value={values.timezone}
                  closeMenuOnSelect={true}
                  closeMenuOnScroll={true}
                  onMenuOpen={onChangeTimeZoneHanlder}
                />
              )}
              <span className="error">
                {errors.timezone && touched.timezone && errors.timezone}
              </span>
            </div>
            {parseInt(values.mediumshipLevel) === 3 &&  (
              <>
              <div className="row-one-step">
             
             
                <label>{t("profile.cancellationPolicy")}</label>
                <Editor
                  // initialContentState={JSON.parse(values.biographicalInfo)}
                  placeholder={t("profile.writeHere")}
                  editorState={editorState1}
                  toolbarClassName="editor-toolbar"
                  wrapperClassName="editor-wrapper"
                  editorClassName="editor"
                  // onEditorStateChange={(editorState) => handleEditorStateChange(editorState, setFieldValue, 'biographicalInfo')}
                  onEditorStateChange={setEditorState1}
                  onContentStateChange={handleContentStateChange1}
                  toolbar={toolbar}
                  // localization={localization}
                  spellCheck
                // stripPastedStyles
                // toolbarCustomButtons={[<CustomComponent />]}
                />
             
            </div>
              <div className="row-one-step textarea biographical_info_wrapper">
                <label>{t("profile.biographicalInfo")}</label>
                {/* <textarea
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.biographicalInfo}
                  //   style="text"
                  id="biographicalInfo"
                  name="biographicalInfo"
                  placeholder="Write Here..."
                  rows="4"
                  cols="50"
                ></textarea> */}
                {/* <Editors
                 name="description"
                 onChange={(data) => {
                   setData(data);
                 }}
                 editorLoaded={editorLoaded}/> */}
                {/* <br /> */}
                {/* {console.log(JSON.parse(values.biographicalInfo),"va;ues")} */}
                {/* {console.log(editorState, 'editorState')} */}
                <Editor
                  // initialContentState={JSON.parse(values.biographicalInfo)}
                  placeholder={t("profile.writeHere")}
                  editorState={editorState}
                  toolbarClassName="editor-toolbar"
                  wrapperClassName="editor-wrapper"
                  editorClassName="editor"
                  // onEditorStateChange={(editorState) => handleEditorStateChange(editorState, setFieldValue, 'biographicalInfo')}
                  onEditorStateChange={setEditorState}
                  onContentStateChange={handleContentStateChange}
                  toolbar={toolbar}
                  // localization={localization}
                  spellCheck
                // stripPastedStyles
                // toolbarCustomButtons={[<CustomComponent />]}
                />
                {/* <div dangerouslySetInnerHTML={{ __html: contentState }} /> */}
                {/* {console.log(contentState,"contentState")} */}

              </div>
              </>
            )}
  {/* <div className="row-one-step textarea biographical_info_wrapper">
                <label>As A Coach</label>
               
                <Editor
                 
                  placeholder="Write Here..."
                  editorState={editorState3}
                  toolbarClassName="editor-toolbar"
                  wrapperClassName="editor-wrapper"
                  editorClassName="editor3"
                 
                  onEditorStateChange={setEditorState3}
                  onContentStateChange={handleContentStateChange}
                  toolbar={toolbar}
                 
                  spellCheck
                
                />
             
              </div> */}
            <div className="update">
              <button
                type="submit"
                className="update"
                onClick={() => {
                  setFieldTouched("mediumshipSpecialities", true, true);
                  setFieldTouched("country", true, true);
                  setFieldTouched("mediumshipLevel", true, true);
                  setFieldTouched("timezone", true, true);
                }}
              >
                {t("buttons.update")}
              </button>
            </div>
            {/* <div className="edite-bution">
            <a href="#">
              <img src="images/edite.png" />
            </a>
          </div> */}
          </form>
        )}
      </Formik>
    </div>
  );
}
